import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonModule } from '@angular/material/button';
import { ActivatedRoute, Router } from '@angular/router';
import { VendorService } from '../../services/vendor-service';

@Component({
  selector: 'app-vendor-evaluation',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatCheckboxModule,
    MatButtonModule
  ],
  templateUrl: './vendor-evaluation.component.html',
  styleUrls: ['./vendor-evaluation.component.css']
})
export class VendorEvaluationComponent implements OnInit {

  evaluationForm!: FormGroup;

  isLoading = false;

  managementCertFileName = '';
  appreciationLettersFileName = '';
  zakatCertificateFileName = '';
  majorCustomersFileName = '';

  managementCertBase64 = '';
  appreciationLettersBase64 = '';
  zakatCertificateBase64 = '';
  majorCustomersBase64 = '';

  approvalId!: number;

  constructor(private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router, private vendorService: VendorService
  ) { }

  ngOnInit(): void {
  this.route.paramMap.subscribe(params => {
    this.approvalId = Number(params.get('id'));
    // console.log(this.approvalId);
  });

    this.evaluationForm = this.fb.group({
      headOfficeLocation: [''],
      // website: [''],
      website: [
    '',
    [
      Validators.pattern(
        /^(https?:\/\/)?([\w-]+\.)+[\w-]{2,}(\/.*)?$/i
      )
    ]
    ],
      branchesInfo: [''],

      managementCertified: [false],
      managementStandards: [''],

      majorCustomers: [''],

      materialCertificates: [false],
      materialCertificatesNotes: [''],

      afterSalesSupport: [''],
      listOfEnclosures: ['']
    });
  }

  onFileChange(event: any, type: string): void {

    const file = event.target.files?.[0];

    if (!file) {
      return;
    }

    const reader = new FileReader();

    reader.onload = () => {

      const base64 = (reader.result as string).split(',')[1];

      switch (type) {

        case 'ManagementCert':
          this.managementCertFileName = file.name;
          this.managementCertBase64 = base64;
          break;

        case 'AppreciationLetters':
          this.appreciationLettersFileName = file.name;
          this.appreciationLettersBase64 = base64;
          break;

        case 'ZakatCertificate':
          this.zakatCertificateFileName = file.name;
          this.zakatCertificateBase64 = base64;
          break;

        case 'MajorCustomersFile':
          this.majorCustomersFileName = file.name;
          this.majorCustomersBase64 = base64;
          break;
      }
    };

    reader.readAsDataURL(file);
  }

 submitEvaluation(): void {

  if (this.evaluationForm.invalid) {
    this.evaluationForm.markAllAsTouched();
    return;
  }

  this.isLoading = true;
  const payload = {
    jsonrpc: '2.0',
    method: 'call',
    params: {
      ApprovalID:this.approvalId,
      HeadOfficeLocation:
        this.evaluationForm.value.headOfficeLocation,

      Website:
        this.evaluationForm.value.website,

      BranchesInfo:
        this.evaluationForm.value.branchesInfo,

      ManagementCertified:
        this.evaluationForm.value.managementCertified,

      ManagementStandards:
        this.evaluationForm.value.managementStandards,

      ManagementCertFile:
        this.managementCertBase64,

      ManagementCertFileFilename:
        this.managementCertFileName,

      AppreciationLetters:
        this.appreciationLettersBase64,

      AppreciationLettersFilename:
        this.appreciationLettersFileName,

      ZakatCertificate:
        this.zakatCertificateBase64,

      ZakatCertificateFilename:
        this.zakatCertificateFileName,

      MajorCustomers:
        this.evaluationForm.value.majorCustomers,

      MajorCustomersFile:
        this.majorCustomersBase64,

      MajorCustomersFileFilename:
        this.majorCustomersFileName,

      MaterialCertificates:
        this.evaluationForm.value.materialCertificates,

      MaterialCertificatesNotes:
        this.evaluationForm.value.materialCertificatesNotes,

      AfterSalesSupport:
        this.evaluationForm.value.afterSalesSupport,

      ListOfEnclosures:
        this.evaluationForm.value.listOfEnclosures      
    }
  };

  this.vendorService
      .vendorEvaluation(payload)
      .subscribe({
        next: (res: any) => {

          this.isLoading = false;

          if (res?.result?.approval_id) {

            this.router.navigate([
              '/registration-success',
              res.result.approval_id,
              'vendor'
            ]);

          } else {

            console.error('Approval ID not received');
          }
        },
        error: (err) => {

          this.isLoading = false;

          console.error(err);
        }
      });
}
}